import { Navigate, Route } from "react-router-dom";

import { List, Create, Edit } from "../components";

const organizationRoutes = [
    <Route index element={<Navigate to="list" replace />} key={"organization:index"} />,
    <Route path="list" element={<List />} key={"organization:list"} />,
    <Route path="create" element={<Create />} key={"organization:create"} />,
    <Route path=":organizationId" element={<Edit />} key={"organization:edit"} />,
];

export default organizationRoutes;
